import "../styles/Modalusergrivevance.css"; // ✅ Import du CSS

export default function Modal({ isOpen, onClose, onSave, grievance, handleEditChange, statuses }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        
        {/* Bouton de fermeture */}
        <button onClick={onClose} className="modal-close">✖</button>

        <h2 className="modal-title">Modifier la doléance</h2>

        {/* Titre */}
        <label className="modal-label">Titre :</label>
        <input
          type="text"
          name="title"
          value={grievance.title}
          onChange={handleEditChange}
          className="modal-input"
        />

        {/* Description */}
        <label className="modal-label">Description :</label>
        <textarea
          name="description"
          value={grievance.description}
          onChange={handleEditChange}
          className="modal-textarea"
        ></textarea>

        {/* Statut */}
        <label className="modal-label">Statut :</label>
        <select
          name="statuts"
          value={grievance.statuts}
          onChange={handleEditChange}
          className="modal-select"
        >
          {statuses.map((status) => (
            <option key={status.value} value={status.value}>
              {status.label}
            </option>
          ))}
        </select>

        {/* Boutons */}
        <div className="modal-actions">
          <button onClick={onClose} className="modal-button modal-cancel">
            Annuler
          </button>
          <button onClick={onSave} className="modal-button modal-save">
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}
